import { useAnnotateKsDiscrepancyMutation } from '@shared/api';
import type { KsDiscrepancy } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import { Button } from '@shared/ui/Button';
import { useAgentPermission } from '@entities/user';
import { decisionLabel } from '@shared/lib/smetaLabels';
import { discrTone, kindLabel } from './ksCheckLabels';
import { DecisionBtns, MutedMargin, Table } from './styled';

interface DiscrepanciesTableProps {
  items: KsDiscrepancy[];
  actId: string;
}

export function DiscrepanciesTable({ items, actId }: DiscrepanciesTableProps) {
  const [annotate, { isLoading }] = useAnnotateKsDiscrepancyMutation();
  const { can_write } = useAgentPermission('smeta');
  if (items.length === 0) {
    return <MutedMargin>Расхождений не найдено.</MutedMargin>;
  }
  return (
    <Table>
      <thead>
        <tr>
          <th>Важность</th>
          <th>Тип</th>
          <th>Уровень</th>
          <th>Сообщение</th>
          <th>Решение</th>
        </tr>
      </thead>
      <tbody>
        {items.map((d) => (
          <tr key={d.id}>
            <td>
              <Badge $tone={discrTone(d.severity)}>{d.severity}</Badge>
            </td>
            <td>{kindLabel(d.kind)}</td>
            <td>{d.ks_act_item_id ? 'позиция' : 'акт'}</td>
            <td>{d.message}</td>
            <td>
              {d.decision !== 'pending' ? (
                <Badge
                  $tone={
                    d.decision === 'accepted'
                      ? 'success'
                      : d.decision === 'rejected'
                        ? 'neutral'
                        : 'warning'
                  }
                >
                  {decisionLabel(d.decision)}
                </Badge>
              ) : (
                <DecisionBtns>
                  <Button
                    $variant="ghost"
                    $size="sm"
                    type="button"
                    disabled={isLoading || !can_write}
                    title={!can_write ? 'Только чтение' : undefined}
                    onClick={() => annotate({ id: d.id, actId, decision: 'accepted' })}
                  >
                    Принять
                  </Button>
                  <Button
                    $variant="ghost"
                    $size="sm"
                    type="button"
                    disabled={isLoading || !can_write}
                    title={!can_write ? 'Только чтение' : undefined}
                    onClick={() => annotate({ id: d.id, actId, decision: 'disputed' })}
                  >
                    Спорно
                  </Button>
                  <Button
                    $variant="ghost"
                    $size="sm"
                    type="button"
                    disabled={isLoading || !can_write}
                    title={!can_write ? 'Только чтение' : undefined}
                    onClick={() => annotate({ id: d.id, actId, decision: 'rejected' })}
                  >
                    Отклонить
                  </Button>
                </DecisionBtns>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
